import { useState } from 'react'
import styled from 'styled-components'
import { Icon, Modal } from 'react-materialize'
import SelectionOptions from './SelectionOptions.react'
import UploadCSV from '../Content/UploadCSV/UploadCSV.react'
import ManualAddTransaction from '../Content/ManualAddTransaction/ManualAddTransaction'

const StyledConciliateModal = styled(Modal)<{
  $modalState: string
  $preventScrolling: boolean
}>`
  ${(props) =>
    props.$modalState !== 'INITIAL'
      ? 'min-width: min-content'
      : 'width: 48rem'};
  max-height: 85%;

  .modal-footer {
    height: 0px;
    padding: 0px;
  }

  .modal-content {
    padding: 0;
    margin-top: 0;
  }

  .body {
    padding-left: 2rem;
    padding-right: 2rem;
    padding-top: 2rem;
  }

  .header {
    display: flex;
    align-items: center;
    height: 8rem;
    background: linear-gradient(135deg, #0f82c5, #07bb9c);
    color: white;
    padding: 1rem;

    h4 {
      font-size: 3rem;
      margin-left: auto;
      margin-right: auto;
    }

    i {
      font-size: 3rem;
      cursor: pointer;
      :hover {
        font-weight: bold;
      }
    }

    .previous {
      position: absolute;
      font-size: 4rem;
    }

    .close {
      position: absolute;
      right: 0;
      margin-right: 1rem;
    }
  }

  .transaction-action-list {
    display: flex;
    flex-direction: column;
    margin-bottom: 3rem;
    width: max-content;
    margin-left: auto;
    margin-right: auto;
  }
`

type ConciliateTransactionsModalType = {
  open: boolean
  handleToggle: (x?: boolean) => void
}

const ConciliateTransactionsModal = ({
  open = false,
  handleToggle,
}: ConciliateTransactionsModalType) => {
  const [modalState, setModalState] = useState('INITIAL')
  const [header, setHeader] = useState('Add Transactions')

  const handleClose = () => {
    setModalState('INITIAL')
    handleToggle()
  }

  const handleClick = (value: string) => {
    setModalState(value)
    switch (value) {
      case 'ADD_JOURNAL_ENTRY':
        return setHeader('Add Journal Entry')
      case 'UPLOAD_CSV':
        return setHeader('Upload Transaction CSV')
      case 'ADD_TRANSACTION':
        return setHeader('Add Transaction')
      default:
        return setHeader('Add Transactions')
    }
  }

  return (
    <StyledConciliateModal
      $modalState={modalState}
      $preventScrolling
      open={open}
      options={{}}
      actions={[]}
    >
      <div className={'header'}>
        {modalState !== 'INITIAL' && (
          <Icon onClick={() => handleClick('INITIAL')} className={'previous'}>
            navigate_before
          </Icon>
        )}
        <h4>{header}</h4>
        <Icon className={'close'} onClick={handleClose}>
          close
        </Icon>
      </div>
      <div className={'body'}>
        {modalState === 'INITIAL' && (
          <SelectionOptions handleClick={handleClick} />
        )}
        {/*{modalState === 'ADD_JOURNAL_ENTRY' && <ManualAddJournalEntry />}*/}
        {modalState === 'UPLOAD_CSV' && <UploadCSV />}
        {modalState === 'ADD_TRANSACTION' && <ManualAddTransaction />}
      </div>
    </StyledConciliateModal>
  )
}

export default ConciliateTransactionsModal
